import type {Task} from './types';
import {MOCK_TODAY} from '@lib/utils';

const tomorrow = new Date(MOCK_TODAY);
tomorrow.setDate(tomorrow.getDate() + 1);
const nextWeek = new Date(MOCK_TODAY);
nextWeek.setDate(nextWeek.getDate() + 7);
const yesterday = new Date(MOCK_TODAY);
yesterday.setDate(yesterday.getDate() - 1);

export const MOCK_TASKS: Task[] = [
  {
    id: 'T-01',
    title: 'Провести разбор звонка с ООО Лидер',
    priority: 'high',
    status: 'in_progress',
    managerId: 'emp-1',
    manager: 'Алексей К.',
    text: 'Разобрать работу с возражением "Сложно внедрить". Звонок C-1841.',
    communicationId: 'C-1841',
    dueDate: tomorrow.toISOString().split('T')[0],
    createdAt: `${MOCK_TODAY}T09:00:00Z`,
    creator: 'rop',
    withObserver: false,
    comments: [
      {
        id: 'C-1',
        author: 'Алексей П.',
        authorUserSid: 'mock-user-sid',
        updatedAt: null,
        text: 'Подготовил черновик разбора, обсудим завтра на 1:1. @Алексей послушай 4-ю и 7-ю минуты звонка.',
        mentions: ['Алексей К.'],
        createdAt: '2026-05-18 10:32',
      },
    ],
  },
  {
    id: 'T-02',
    title: 'Обучение по скрипту возражений',
    priority: 'high',
    status: 'planned',
    managerId: 'emp-3',
    manager: 'Иван С.',
    text: 'Пройти модуль "Работа с возражением Дорого" в учебной системе.',
    communicationId: null,
    dueDate: nextWeek.toISOString().split('T')[0],
    createdAt: `${MOCK_TODAY}T09:30:00Z`,
    creator: 'rop',
    withObserver: false,
    comments: [],
  },
  {
    id: 'T-03',
    title: 'Прослушать образцовый звонок Анны',
    priority: 'medium',
    status: 'queued',
    managerId: null,
    manager: null,
    text: 'Разослать звонок C-1160 всем менеджерам как пример лучшей практики.',
    communicationId: 'C-1160',
    dueDate: nextWeek.toISOString().split('T')[0],
    createdAt: `${MOCK_TODAY}T10:00:00Z`,
    creator: 'rop',
    withObserver: false,
    comments: [],
  },
  {
    id: 'T-04',
    title: 'Подготовить план развития',
    priority: 'medium',
    status: 'planned',
    managerId: 'emp-5',
    manager: 'Дмитрий Р.',
    text: 'Составить индивидуальный план развития на месяц с фокусом на конверсию.',
    communicationId: null,
    dueDate: nextWeek.toISOString().split('T')[0],
    createdAt: `${MOCK_TODAY}T10:30:00Z`,
    creator: 'rop',
    withObserver: false,
    comments: [],
  },
  {
    id: 'T-05',
    title: 'Встреча с командой по итогам недели',
    priority: 'medium',
    status: 'planned',
    managerId: null,
    manager: null,
    text: 'Разбор ключевых звонков, обмен практиками, постановка целей.',
    communicationId: null,
    dueDate: nextWeek.toISOString().split('T')[0],
    createdAt: `${MOCK_TODAY}T11:00:00Z`,
    creator: 'rop',
    withObserver: false,
    comments: [],
  },
  {
    id: 'T-06',
    title: 'Разобрать причины низкой конверсии',
    priority: 'high',
    status: 'paused',
    managerId: 'emp-7',
    manager: 'Сергей М.',
    text: 'Конверсия упала до 38% за неделю. Проанализировать 5 последних звонков.',
    communicationId: null,
    dueDate: tomorrow.toISOString().split('T')[0],
    createdAt: `${MOCK_TODAY}T08:00:00Z`,
    creator: 'rop',
    withObserver: false,
    comments: [],
  },
  {
    id: 'T-07',
    title: 'Подготовка к презентации продукта',
    priority: 'medium',
    status: 'in_progress',
    managerId: 'emp-2',
    manager: 'Мария П.',
    text: 'Обновить слайды и отработать демо перед встречей с АО Альфа.',
    communicationId: 'C-1115',
    dueDate: tomorrow.toISOString().split('T')[0],
    createdAt: `${MOCK_TODAY}T07:30:00Z`,
    creator: 'rop',
    withObserver: false,
    comments: [],
  },
  {
    id: 'T-08',
    title: 'Отчёт по воронке за месяц',
    priority: 'low',
    status: 'done',
    managerId: null,
    manager: null,
    text: 'Подготовить сводный отчёт по конверсии и среднему баллу за апрель.',
    communicationId: null,
    dueDate: yesterday.toISOString().split('T')[0],
    createdAt: new Date(MOCK_TODAY).toISOString(),
    creator: 'rop',
    withObserver: false,
    comments: [],
  },
  {
    id: 'T-09',
    title: 'Запросить обратную связь у клиента',
    priority: 'low',
    status: 'partial',
    managerId: 'emp-4',
    manager: 'Ольга Т.',
    text: 'Позвонить клиенту ООО Бета и узнать решение по предложению.',
    communicationId: 'C-1145',
    dueDate: tomorrow.toISOString().split('T')[0],
    createdAt: `${MOCK_TODAY}T12:00:00Z`,
    creator: 'manager',
    creatorUserSid: 'mock-user-sid',
    withObserver: true,
    comments: [],
  },
  {
    id: 'T-10',
    title: 'Обновить базу возражений',
    priority: 'low',
    status: 'queued',
    managerId: null,
    manager: null,
    text: 'Добавить новые возражения из звонков последних 2 недель в базу знаний.',
    communicationId: null,
    dueDate: nextWeek.toISOString().split('T')[0],
    createdAt: `${MOCK_TODAY}T13:00:00Z`,
    creator: 'rop',
    withObserver: false,
    comments: [],
  },
];
